module.exports = __webpack_public_path__ + "img/11.00a56031.png";